<template>
  <div class="setting-main-container">
        <div class="card setting-card">
            <div class="page-header d-flex justify-content-between">
                <div>
                <h3 class="page-title">
                    {{ $t('profile.stakeholder.title') }}
                </h3>
    
                </div>
                <base-button
                    outline
                    class="add-new-tax"
                    color="theme"
                    @click="addOwnerPartnerDirector"
                >
                    {{ $t('profile.stakeholder.add_new') }}
                </base-button>
            </div>

            <table-component
              ref="stakeholderTable"
              :show-filter="false"
              :data="stakeholders"
              table-class="table tax-table"
              class="mb-3"
              
            >
            <table-column
              :sortable="true"
              :label="$t('profile.stakeholder.name')"
              show="name"
            />
             <table-column
              :sortable="true"
              :label="$t('profile.stakeholder.role')"
              show="role"
            />
            <table-column
              :sortable="true"
              :label="$t('profile.stakeholder.cnic')"
              show="cnic"
            />

            <table-column
              :sortable="false"
              :filterable="false"
              cell-class="action-dropdown"
            >
              <template slot-scope="row">
                <span>{{ $t('settings.tax_types.action') }}</span>
                <v-dropdown>
                  <a slot="activator" href="#">
                    <dot-icon />
                  </a>
                  <v-dropdown-item>
                    <div class="dropdown-item" @click="editStakeHolder(row)">
                      <font-awesome-icon :icon="['fas', 'pencil-alt']" class="dropdown-item-icon" />
                      {{ $t('general.edit') }}
                    </div>
                  </v-dropdown-item>
                </v-dropdown>
              </template>
            </table-column>
            
        </table-component>
      </div>
    </div>
</template>
<script>
import { validationMixin } from 'vuelidate'
import { mapActions, mapGetters } from 'vuex'
import moment from 'moment'
const { required, maxLength, alpha,minLength,email } = require('vuelidate/lib/validators')
export default {
  mixins: [validationMixin],
  data () {
    return {
      activeTab: 'BUSINESSDETAILS',
      formData:{}
    }
  },
  computed: {
    ...mapGetters('stakeholder', [
      'stakeholders'
    ]),
  },   
  watch: {
  },
  validations: {
     formData: {}
  },
  created() {
       
  },
  methods: {
    ...mapActions('modal', [
      'openModal'
    ]),
    ...mapActions('business', [
      'addBusiness',
      'updateBusiness'
    ]), 
    addOwnerPartnerDirector(){
       this.openModal({
        'title': 'Add Owner/Partner/Director',
        'componentName': 'StakeholderModal',
      })
      this.$refs.stakeholderTable.refresh()
    },
    editStakeHolder(data){
       this.openModal({
        'title': 'Edit Owner/Partner/Director',
        'componentName': 'StakeholderModal',
        'id': data.id,
        'data': data
      })
      this.$refs.stakeholderTable.refresh()
    },
  }
}
</script>
